const icon = require('vue-svgicon');
icon.register({
    'caret-top': {
        width: 1024,
        height: 1024,
        viewBox: '0 0 1024 1024',
        data: `<path pid="0" d="M996.072 701.092l-37.236 37.236L512 286.838 65.164 738.328l-37.236-37.236L512 221.674z"/>`,
    },
});
